import axios from 'axios'
const  production = ''
const local = 'https://food-manage.onrender.com'
const api = axios.create({
    baseURL: `${local}/api/v1`,
    withCredentials : true
})
export default api
